module.exports = __webpack_public_path__ + "img/createjs-logopng.c073a8f7.png";